'use client';

import { Button } from '../../lib/components';
import { useTranslations } from '../../lib/i18n/TranslationsProvider';

export interface SignInFormProps {
	inProgress: boolean;
	onSubmit: () => void;
}

export const SignInForm = ({ inProgress, onSubmit }: SignInFormProps) => {
	const { t } = useTranslations();

	return (
		<div className="h-screen w-full flex justify-center items-center">
			<div className="max-sm:px-5 p-10 border border-takeda-medium-grey-600 max-w-[480px] max-sm:w-full max-sm:mx-4 bg-white">
				<div>
					<h1 className="text-md mb-2 uppercase border-b-2 border-light-grey pb-2 font-medium">
						{t.general.accessControl.MsalTitle}
					</h1>
					<p className="mb-5 text-sm">{t.general.accessControl.MsalDescription}</p>
					<Button className="w-full" onPress={onSubmit} isDisabled={inProgress}>
						{inProgress
							? t.general.accessControl.MsalSigningInMessage
							: t.general.accessControl.MsalSignInButton}
					</Button>
				</div>
			</div>
		</div>
	);
};
